module.exports = __webpack_public_path__ + "img/ad-20211102-a-bg.05babd40.png";